import { Injectable } from '@angular/core';
import { WladajacyResponseDto } from '../../../../gk-map/models';
import { GridDataService } from '../../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspBuildingsOwnerGridDataService extends GridDataService<WladajacyResponseDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
